import { createSlice } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus } from "../common/enums";

// Mirrors PUT /progress-audit/progress/:progressId/lessons/:lessonSubdocumentId/fix
// (service-learning, SuperAdmin only) - the manual correction for a lesson
// the student actually finished but whose progress never reached 1 in
// Progress (SYSTEM.debt.md ítem 29/§15.29).
interface ProgressAuditFixLessonState {
  status: FetchStatus;
}

const initialState: ProgressAuditFixLessonState = {
  status: FetchStatus.Idle,
};

export const progressAuditFixLessonSlice = createSlice({
  name: "progressAuditFixLesson",
  initialState,
  reducers: {
    fixing: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fixed: (state) => {
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fixing, fixed, error } = progressAuditFixLessonSlice.actions;

export const fixProgressAuditLesson = (
  progressId: string,
  lessonSubdocumentId: string,
  onSuccess: () => void = () => {},
  onError: () => void = () => {}
) => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: `/progress-audit/progress/${progressId}/lessons/${lessonSubdocumentId}/fix`,
      types: {
        requestType: fixing,
        successTypes: [
          {
            actionOrCreator: fixed,
            selector: () => {
              onSuccess();
            },
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
            selector: () => {
              onError();
            },
          },
        ],
      },
      method: HttpMethods.PUT,
      microservice: Microservices.LEARNING_SERVICE,
      authenticated: true,
    })
  );
};

export const selectIsFixingProgressAuditLesson = (state: RootState) =>
  state.progressAuditFixLesson.status === FetchStatus.Fetching;

export default progressAuditFixLessonSlice.reducer;
